import { render, staticRenderFns } from "./EditFontsForm.vue?vue&type=template&id=2d83b3d4&"
import script from "./EditFontsForm.vue?vue&type=script&lang=js&"
export * from "./EditFontsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports